// USA Business Card Standards and Typography Guidelines

export const BUSINESS_CARD_STANDARDS = {
  // USA Standard Dimensions
  dimensions: {
    width: 3.625, // inches
    height: 2.125, // inches
    widthPx: 1044, // pixels at 300 DPI
    heightPx: 612, // pixels at 300 DPI
    bleed: 0.125, // 1/8 inch bleed
    safeZone: 0.125 // 1/8 inch safe zone from edges
  },
  
  // Orientation options
  orientations: {
    horizontal: { width: 3.625, height: 2.125 },
    vertical: { width: 2.125, height: 3.625 }
  },
  
  // Professional Typography Standards
  typography: {
    companyName: {
      minSize: 14, // pts
      maxSize: 20, // pts
      recommendedSize: 16,
      weight: 'bold',
      importance: 1
    },
    personalName: {
      minSize: 10,
      maxSize: 14,
      recommendedSize: 12,
      weight: 'semibold',
      importance: 2
    },
    jobTitle: {
      minSize: 8,
      maxSize: 12,
      recommendedSize: 10,
      weight: 'normal',
      importance: 3
    },
    contactInfo: {
      minSize: 7,
      maxSize: 10,
      recommendedSize: 8,
      weight: 'normal',
      importance: 4
    },
    website: {
      minSize: 7,
      maxSize: 10,
      recommendedSize: 8,
      weight: 'normal',
      importance: 4
    },
    address: {
      minSize: 6,
      maxSize: 9,
      recommendedSize: 7,
      weight: 'normal',
      importance: 5
    }
  },
  
  // Color guidelines
  colors: {
    primary: '#000000', // Black for text
    secondary: '#333333', // Dark gray
    accent: '#666666', // Medium gray
    background: '#FFFFFF' // White
  },
  
  // Spacing guidelines
  spacing: {
    logoSize: { width: 60, height: 60 }, // pixels
    margins: { top: 36, right: 36, bottom: 36, left: 36 }, // pixels
    lineHeight: 1.2,
    elementSpacing: 8 // pixels between elements
  }
};

export const GOOGLE_FONTS = [
  // Professional Sans-Serif
  { 
    name: 'Inter', 
    family: 'Inter, sans-serif',
    category: 'Sans-serif',
    weights: ['300', '400', '500', '600', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',
    professional: true
  },
  { 
    name: 'Poppins', 
    family: 'Poppins, sans-serif',
    category: 'Sans-serif',
    weights: ['300', '400', '500', '600', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap',
    professional: true
  },
  { 
    name: 'Open Sans', 
    family: 'Open Sans, sans-serif',
    category: 'Sans-serif',
    weights: ['300', '400', '500', '600', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap',
    professional: true
  },
  { 
    name: 'Montserrat', 
    family: 'Montserrat, sans-serif',
    category: 'Sans-serif',
    weights: ['300', '400', '500', '600', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap',
    professional: true
  },
  
  // Professional Serif
  { 
    name: 'Playfair Display', 
    family: 'Playfair Display, serif',
    category: 'Serif',
    weights: ['400', '500', '600', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap',
    professional: true
  },
  { 
    name: 'Merriweather', 
    family: 'Merriweather, serif',
    category: 'Serif',
    weights: ['300', '400', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap',
    professional: true
  },
  
  // Modern Professional
  { 
    name: 'Roboto', 
    family: 'Roboto, sans-serif',
    category: 'Sans-serif',
    weights: ['300', '400', '500', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap',
    professional: true
  },
  { 
    name: 'Lato', 
    family: 'Lato, sans-serif',
    category: 'Sans-serif',
    weights: ['300', '400', '700'],
    url: 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap',
    professional: true
  }
];

export const PHOTO_GUIDELINES = {
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  recommendedDimensions: {
    width: 400,
    height: 400
  },
  quality: 0.9
};

// Business card design rules
export const DESIGN_RULES = {
  // Text hierarchy (most important to least)
  textHierarchy: [
    'companyName',
    'personalName', 
    'jobTitle',
    'phone',
    'email',
    'website',
    'address'
  ],
  
  // Color contrast requirements (WCAG AA)
  minContrast: {
    normalText: 4.5,
    largeText: 3.0
  },
  
  // Maximum elements for readability
  maxElements: {
    front: 6,
    back: 8
  },
  
  // Professional layout ratios
  goldenRatio: 1.618,
  
  // Safe zones (no important content)
  safeZones: {
    bleedZone: 0.125, // inches
    textZone: 0.25    // inches from edge
  }
};